import { trackEvent as trackerTrackEvent } from '@tuic/tracking';
import { normalizeTrackingValue } from '@tuic/tracking/src/utils/normalize-tracking-value';

import { trackTealium } from '../src/tracking';
import { isUsingTrackerModule } from '../tracking/tealium-helper';

import type { EventData, PageViewData } from '../tracking/tealium';

export const formatTrackingString = normalizeTrackingValue;

export const trackPageView = (data: PageViewData) => {
  trackTealium(data, 'Pageview');
};

/**
 * Use `queueTrackEvent` instead.
 */
export const trackEvent = (data: EventData) => {
  if (isUsingTrackerModule()) {
    trackerTrackEvent(data);
    return;
  }

  trackTealium(data, 'Event');
};
